import common from './de/common';
import shell from './de/shell';
import heute from './de/heute';
import mehr from './de/mehr';
import settings from './de/settings';
import activities from './de/activities';
import activity from './de/activity';
import maps from './de/maps';
import analysis from './de/analysis';
import health from './de/health';
import goals from './de/goals';
import planning from './de/planning';
import wrapped from './de/wrapped';
import weather from './de/weather';
import races from './de/races';
import season from './de/season';
import gear from './de/gear';

/**
 * Deutsch ist die Quelle: jede Seite hat ihren Namensraum unter `de/`.
 * Pluralformen als { one, other }, Platzhalter als {name}.
 */
export const de = { common, shell, heute, mehr, settings, activities, activity, maps, analysis, health, goals, planning, wrapped, weather, races, season, gear };

type Widen<T> = { [K in keyof T]: T[K] extends string ? string : Widen<T[K]> };
export type Messages = Widen<typeof de>;
